/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddVideosResponse
 */
export interface AddVideosResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddVideosResponse
     */
    videoIds: Array<string>;
}

/**
 * Check if a given object implements the AddVideosResponse interface.
 */
export function instanceOfAddVideosResponse(value: object): value is AddVideosResponse {
    if (!('videoIds' in value) || value['videoIds'] === undefined) return false;
    return true;
}

export function AddVideosResponseFromJSON(json: any): AddVideosResponse {
    return AddVideosResponseFromJSONTyped(json, false);
}

export function AddVideosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddVideosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'videoIds': json['video_ids'],
    };
}

export function AddVideosResponseToJSON(json: any): AddVideosResponse {
    return AddVideosResponseToJSONTyped(json, false);
}

export function AddVideosResponseToJSONTyped(value?: AddVideosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'video_ids': value['videoIds'],
    };
}

